import React, { useState } from "react";
import { UserPlus, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function FollowButton({ sellerId, initial = false }) {
  const { user, guest } = useAuth();
  const [following, setFollowing] = useState(initial);
  const [busy, setBusy] = useState(false);
  if (!user || guest || user.user_id === sellerId) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      await api(`/follow/${sellerId}`, { method: following ? "DELETE" : "POST" });
      setFollowing((v) => !v);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <button data-testid="follow-button" disabled={busy} onClick={toggle} className={`flex items-center gap-1.5 px-4 py-2.5 rounded-2xl font-bold text-sm ${following ? "bg-[#F0F2FA] text-[#161629]" : "bg-[#FF3D5A] text-white"}`}>
      {following ? <UserCheck size={16} /> : <UserPlus size={16} />} {following ? "تتابعه" : "متابعة"}
    </button>
  );
}
